import { useEffect, useRef, useState, type ComponentProps } from "react";
import { Input } from "@/components/ui/input";

type Props = Omit<ComponentProps<typeof Input>, "value" | "onChange" | "type"> & {
  value: number | string;
  onCommit: (value: number) => void;
};

/** Keep unfinished typing out of quote/recipe state; publish one completed edit. */
export function QuotePriceInput({ value, onCommit, onBlur, onFocus, onKeyDown, ...props }: Props) {
  const [draft, setDraft] = useState(String(value));
  const focused = useRef(false);
  const cancelled = useRef(false);
  useEffect(() => {
    if (!focused.current) setDraft(String(value));
  }, [value]);

  return <Input {...props} type="text" inputMode="decimal" value={draft}
    onFocus={event => { focused.current = true; cancelled.current = false; onFocus?.(event); }}
    onChange={event => setDraft(event.target.value)}
    onKeyDown={event => {
      if (event.key === "Enter") {
        event.preventDefault();
        event.currentTarget.blur();
      } else if (event.key === "Escape") {
        event.preventDefault();
        cancelled.current = true;
        event.currentTarget.blur();
      }
      onKeyDown?.(event);
    }}
    onBlur={event => {
      focused.current = false;
      const text = draft.trim();
      const next = Number(text);
      // Blank or invalid input is not an instruction to erase a valid price.
      if (!cancelled.current && /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(text) && Number.isFinite(next) && next >= 0 && next !== Number(value)) {
        onCommit(next);
      }
      setDraft(String(value));
      cancelled.current = false;
      onBlur?.(event);
    }} />;
}
